import { useState, useEffect } from 'react'

export const usePortal = (selector = 'header-portal') => {
  const [portal, setPortal] = useState<HTMLElement | null>(null)

  useEffect(() => {
    const portalTarget = document.getElementById(selector)

    if (portalTarget) {
      setPortal(portalTarget)
    }
  }, [])

  return { portal }
}
